import React from 'react'
import Logo from '@/components/common/Logo'
import { CrossBtn } from '@/components/controls/CrossBtn'

interface SimplePersistentOffcanvasProps {
  show: boolean;
  onClose: () => void;
  children: React.ReactNode;
  side?: 'left' | 'right';
}

export const SimplePersistentOffcanvas: React.FC<SimplePersistentOffcanvasProps> = ({
  show,
  onClose,
  children,
  side = 'right'
}) => {
  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-60 z-40 transition-opacity duration-300 ${show ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
        onClick={onClose}
        aria-hidden="true"
      />
      {/* Offcanvas */}
      <div
        className={`
          p-[24px]
          fixed top-0 ${side === 'left' ? 'left-0' : 'right-0'}
          h-full w-[360px] bg-white shadow-lg z-[9999]
          transition-transform duration-300
          ${show ? 'translate-x-0' : side === 'left' ? '-translate-x-full' : 'translate-x-full'}
        `}
        style={{ willChange: 'transform' }}
      >
        <div className='flex justify-between items-center mb-[24px]'>
          <Logo className='logo--primary !scale-[0.8]' link={'/'} color={'black'}/>
          <CrossBtn className='scale-[0.6]' onClick={() => {
            onClose()
          }}/>
        </div>
        <div style={{ height: 'calc(100% - 80px);' }} className='overflow-y-auto'>{children}</div>
      </div>
    </>
  )
}
